import { render, staticRenderFns } from "./TasksSidebar.vue?vue&type=template&id=11dbc687&scoped=true"
import script from "./TasksSidebar.vue?vue&type=script&lang=js"
export * from "./TasksSidebar.vue?vue&type=script&lang=js"
import style0 from "./TasksSidebar.vue?vue&type=style&index=0&id=11dbc687&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dbc687",
  null
  
)

export default component.exports